<div class="row">
	<div class="col-lg-12">
		<ol class="breadcrumb">
			<li><a href="javascript:void(0)" (click)="$state.go('missioncontrol.dashboard', {}, {reload: true})">Home</a></li>
			<li class="active"><span>Candidates</span></li>
		</ol>
		<h1 *ngIf="candidatesContainer.busy" id="candidatesTitle" class="heading-css">Candidates (<span class="skeleton-loading candidates-count-skeleton"></span>)</h1>
		<h1 *ngIf="!candidatesContainer.busy" id="candidatesTitle" class="heading-css">Candidates ({{candidatesContainer.candidatesCount}})</h1>
	</div>
</div>

<div class="row" *ngIf="companyType == 'Corporation'">
	<div class="col-xs-12" style="padding-left: 16px">
		<div class="radio" style="display: inline;">
			<input type="radio" name="candidateType" id="internalCandidates" value="OWN_CANDIDATES"
				[(ngModel)]="candidatesContainer.candidatesQueryFilter.candidateType" (change)="onCandidatesTypeChanged()">
			<label for="internalCandidates">
				<strong>Internal Candidates</strong>
			</label>
		</div>
		<div class="radio" style="display: inline;">
			<input type="radio" name="candidateType" id="vendorCandidates" value="VENDOR_CANDIDATES"
				[(ngModel)]="candidatesContainer.candidatesQueryFilter.candidateType" (change)="onCandidatesTypeChanged()">
			<label for="vendorCandidates">
				<strong>Vendor Candidates</strong>
			</label>
		</div>
	</div>
</div>
<div class="row">
	<div class="col-xs-12">
		<div style="margin:10px;margin-top:20px;font-size:0.9em" class="pull-left mb-0">
			<div *ngIf="candidatesContainer.candidatesQueryFilter.candidateType == 'OWN_CANDIDATES'" class="pull-left">
				<div style="padding-right:10px;" class="pull-left">
					<input type="checkbox" id="assignedToMeFilter" name="assignedToMeFilter"
						[ngModel]="visibilityFilters.assignedToMe === 'assignedToMe'"
						(ngModelChange)="visibilityFilters.assignedToMe = $event ? 'assignedToMe' : ''"
						(click)="visibilityFilterChanged()">
					<label for="assignedToMeFilter">
						<strong>Assigned To Me</strong>
					</label>
				</div>
				<div style="padding-right:10px;" class="pull-left">
					<input type="checkbox" id="assignedToOthersFilter" name="assignedToOthersFilter"
						[ngModel]="visibilityFilters.assignedToOthers === 'assignedToOthers'"
						(ngModelChange)="visibilityFilters.assignedToOthers = $event ? 'assignedToOthers' : ''"
						(click)="visibilityFilterChanged()">
					<label for="assignedToOthersFilter">
						<strong>Assigned To Others</strong>
					</label>
				</div>
				<div class="pull-left pr-3">
					<input type="checkbox" id="unassignedFilter" name="unassignedFilter"
						[ngModel]="visibilityFilters.unassigned === 'unassigned'"
						(ngModelChange)="visibilityFilters.unassigned = $event ? 'unassigned' : ''"
						(click)="visibilityFilterChanged()">
					<label for="unassignedFilter">
						<strong>Unassigned</strong>
					</label>
				</div>
			</div>
		</div>
		<div style="margin: 10px;" class="pull-right">
			<span title="Click to show / hide the filter" class="pull-right filter-icon">
				<i class="fa fa-filter fa-2x cursor-point" aria-hidden="true" id="open-filter"></i>
			</span>
		</div>
		<div style="margin: 10px;" class="pull-right">
			<span *ngIf="!candidatesContainer.busy" (click)="toggleCandidateRowView()">
				<span *ngIf="isRowViewActive" tooltip="Switch to card view" container="body"
					class="fa fa-th-large fa-2x cursor-pointer"></span>
				<span *ngIf="!isRowViewActive" tooltip="Switch to row view" container="body"
					class="fa fa-th-list fa-2x cursor-pointer"></span>
			</span>
			<span *ngIf="candidatesContainer.busy" class="opacity-half pointer-events-none" style="font-size: 24px;">
				<span class="skeleton-loading candidates-view-toggle-skeleton"></span>
			</span>
		</div>
		<div style="margin: 10px;" class="pull-right" [hidden]="hideSearchStringFlag">
			<input id="candidatesSearchText" class="text-center filter-style inputBoxBorder" type="text" (keyup)="onGlobalFilterChange($event)"
				placeholder="Search" [(ngModel)]="candidatesContainer.candidatesQueryFilter.searchString" (ngModelChange)="addToDisplayFilters('search')"/>
		</div>
		<div class="btn-group pull-right pull-right" style="margin: 10px;">
			<a class="btn btn-primary" [hidden]="isVendorCompany" href="javascript:void(0)" (click)="$state.go('missioncontrol.addCandidates', {}, {reload: true})">Add New Candidates</a>
		</div>
	</div>
	<div class="col-xs-12" *ngIf="candidatesContainer.candidatesQueryFilter.candidateType == 'OWN_CANDIDATES'">
		<div class="pull-left ml-3">
			<input type="checkbox" name="includeWithoutCompensation"
				[(ngModel)]="candidatesContainer.candidatesQueryFilter.includeWithoutCompensation"
				(click)="candidateCompensationChanged()">
			<label for="includeWithoutCompensation">
				<strong>Include candidates with no compensation information</strong>
			</label>
		</div>
	</div>
	<!--filter starts-->
	<div class="col-xs-12">
		<div class="row" style="position: relative">
			<div class="col-xs-12" id="search-panel" style="display: none;">
				<div class="main-box" style="padding-top: 1%;">
					<div class="main-box-body clearfix">
						<form role="form" name="" novalidate>
							<div class="row">
								<div class="col-lg-12 col-sm-12 col-md-12">
									<div class="row">
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="clientorbu">Belongs To</label>
												<ng-select *ngIf="!loadingClientsOrBusFilter" [items]="clientOrBuList" bindLabel="name"
													placeholder="None selected" name="clientorbu" id="clientorbu"
													[(ngModel)]="selectedClientOrBuList" [closeOnSelect]="false" [multiple]="true"
													(change)="onClientClick()">
													<ng-template ng-header-tmp>
														<div class="d-flex">
															<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('Clients', 'selectAll')">Select All</div>
															<div class="custom-ng-select-btn" (click)="selectRemoveAll('Clients', 'removeAll')">Select None</div>
														</div>
													</ng-template>
													<ng-template ng-multi-label-tmp let-items="items">
														<span class="ng-value">
															{{ items[0].name }}<i class="fas fa-share-alt share-icon" *ngIf="items[0].companyType === 'Corporation'"></i>{{ items.length > 1 ? ' ... (' + items.length + ')' : '' }}
														</span>
													</ng-template>
													<ng-template ng-option-tmp let-item="item">
														<span style="padding-right:5px">{{ item.name }}</span>
														<i class="fas fa-share-alt" *ngIf="item.companyType === 'Corporation'"></i>
													</ng-template>
												</ng-select>
												<div class="col-sm-12" *ngIf="loadingClientsOrBusFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
											</div>
										</div>
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="candidateStatus">Candidate Status</label>
												<ng-select *ngIf="!loadingCandidateStatusesFilter" [items]="candidateStatusList" bindLabel="name"
													placeholder="None selected" name="candidateStatus" id="candidateStatus"
													[(ngModel)]="selectedCandidateStatusList" [closeOnSelect]="false" [multiple]="true"
													(change)="onCandidateStatusClick()">
													<ng-template ng-header-tmp>
														<div class="d-flex">
															<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('CandidateStatus', 'selectAll')">Select All</div>
															<div class="custom-ng-select-btn" (click)="selectRemoveAll('CandidateStatus', 'removeAll')">Select None</div>
														</div>
													</ng-template>
													<ng-template ng-multi-label-tmp let-items="items">
														<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
													</ng-template>
												</ng-select>
												<div class="col-sm-12" *ngIf="loadingCandidateStatusesFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
											</div>
										</div>
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="requisitionStatus">Requisition Status</label>
												<ng-select *ngIf="!loadingRequisitionStatusesFilter" [items]="requisitionStatusList" bindLabel="name"
													placeholder="None selected" name="requisitionStatus" id="requisitionStatus"
													[(ngModel)]="selectedRequisitionStatusList" [closeOnSelect]="false" [multiple]="true"
													(change)="onRequisitionStatusClick()">
													<ng-template ng-header-tmp>
														<div class="d-flex">
															<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('RequisitionStatus', 'selectAll')">Select All</div>
															<div class="custom-ng-select-btn" (click)="selectRemoveAll('RequisitionStatus', 'removeAll')">Select None</div>
														</div>
													</ng-template>
													<ng-template ng-multi-label-tmp let-items="items">
														<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
													</ng-template>
												</ng-select>
												<div class="col-sm-12" *ngIf="loadingRequisitionStatusesFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
											</div>
										</div>
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="requisitionNumbers">Requisition Number</label>
												<ng-select *ngIf="!loadingRequisitionNumbersFilter" [items]="requisitionNumbersList" bindLabel="selectedDisplayName"
													placeholder="None selected" name="requisitionNumbers" id="requisitionNumbers"
													[(ngModel)]="selectedRequisitionNumbersList" [closeOnSelect]="false" [multiple]="true"
													(search)="onReqNumsSearch($event)" (clear)="getReqNums('')"
													(change)="onRequisitionNumbersClick()">
													<ng-template ng-header-tmp>
														<div class="d-flex">
															<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('RequisitionNumbers', 'selectAll')">Select All</div>
															<div class="custom-ng-select-btn" (click)="selectRemoveAll('RequisitionNumbers', 'removeAll')">Select None</div>
														</div>
													</ng-template>
													<ng-template ng-multi-label-tmp let-items="items">
														<span class="ng-value">
															<i [innerHTML]="items[0].icon"></i>{{ items[0].selectedDisplayName }}{{ items.length > 1 ? ' ... (' + items.length + ')' : '' }}
														</span>
													</ng-template>
													<ng-template ng-option-tmp let-item="item">
														<span [innerHTML]="item.icon"></span>{{ item.name }}
													</ng-template>
												</ng-select>
												<div class="col-sm-12" *ngIf="loadingRequisitionNumbersFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="candidatesSearchFirstName">First Name</label>
												<input type="text" id="candidatesSearchFirstName" name="candidatesSearchFirstName" value="" class="inputBoxTransactionRequisition inputBoxBorder"
													[(ngModel)]="candidatesContainer.candidatesQueryFilter.firstName" (keyup)="onGlobalFilterChange()" (ngModelChange)="addToDisplayFilters('firstName')">
											</div>
										</div>
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="candidatesSearchLastName">Last Name</label>
												<input type="text" id="candidatesSearchLastName" name="candidatesSearchLastName" value="" class="inputBoxTransactionRequisition inputBoxBorder"
													[(ngModel)]="candidatesContainer.candidatesQueryFilter.lastName" (keyup)="onGlobalFilterChange()" (ngModelChange)="addToDisplayFilters('lastName')">
											</div>
										</div>
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="candidatesSearchPhone">Phone</label>
												<input type="text" id="candidatesSearchPhone" name="candidatesSearchPhone" value="" class="inputBoxTransactionRequisition inputBoxBorder"
													[(ngModel)]="candidatesContainer.candidatesQueryFilter.phone" (keyup)="onGlobalFilterChange()" (ngModelChange)="addToDisplayFilters('phone')">
											</div>
										</div>
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="candidatesSearchEmail">Email</label>
												<input type="text" id="candidatesSearchEmail" name="candidatesSearchEmail" value="" class="inputBoxTransactionRequisition inputBoxBorder"
													[(ngModel)]="candidatesContainer.candidatesQueryFilter.email" (keyup)="onGlobalFilterChange()" (ngModelChange)="addToDisplayFilters('email')">
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="jobMatchStates">Job Match States</label>
												<ng-select *ngIf="!loadingJobMatchStatesFilter" [items]="jobMatchStates" bindLabel="label" groupBy="stepGroup"
													[selectableGroup]="true" [selectableGroupAsModel]="false"
													placeholder="None selected" name="jobMatchStates" id="jobMatchStates"
													[(ngModel)]="selectedJobMatchStates" [closeOnSelect]="false" [multiple]="true"
													(change)="onJobMatchStateClick()">
													<ng-template ng-header-tmp>
														<div class="d-flex">
															<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('JobMatchStates', 'selectAll')">Select All</div>
															<div class="custom-ng-select-btn" (click)="selectRemoveAll('JobMatchStates', 'removeAll')">Select None</div>
														</div>
													</ng-template>
													<ng-template ng-multi-label-tmp let-items="items">
														<span class="ng-value">{{ getMultiSelectSummary(items, 'label') }}</span>
													</ng-template>
												</ng-select>
												<div class="col-sm-12" *ngIf="loadingJobMatchStatesFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
											</div>
										</div>
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="recruiters">
													Recruiter<span *ngIf="companyType === 'Corporation'">/Hiring Manager</span><span *ngIf="companyType !== 'Corporation'">/POC</span>
												</label>
												<ng-select *ngIf="!loadingRecruitersFilter" [items]="recruitersList" bindLabel="selectedDisplayName"
													placeholder="None selected" name="recruiters" id="recruiters"
													[(ngModel)]="selectedRecruitersList" [closeOnSelect]="false" [multiple]="true"
													(change)="onRecruiterClick()">
													<ng-template ng-header-tmp>
														<div class="d-flex">
															<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('Recruiters', 'selectAll')">Select All</div>
															<div class="custom-ng-select-btn" (click)="selectRemoveAll('Recruiters', 'removeAll')">Select None</div>
														</div>
													</ng-template>
													<ng-template ng-multi-label-tmp let-items="items">
														<span class="ng-value">{{ getMultiSelectSummary(items, 'selectedDisplayName') }}</span>
													</ng-template>
													<ng-template ng-option-tmp let-item="item">
														<span [innerHTML]="item.name"></span>
													</ng-template>
												</ng-select>
												<div class="col-sm-12" *ngIf="loadingRecruitersFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
											</div>
										</div>
										<div class="col-lg-3 col-sm-3 col-md-3">
											<div class="form-group">
												<label for="workLocations">
													Pref. Work Locations
												</label>
												<ng-select *ngIf="!loadingWorkLocationsFilter" [items]="workLocationList" bindLabel="name"
													placeholder="None selected" name="workLocations" id="workLocations"
													[(ngModel)]="selectedWorkLocationList" [closeOnSelect]="false" [multiple]="true"
													(change)="onWorkLocationClick()">
													<ng-template ng-header-tmp>
														<div class="d-flex">
															<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('WorkLocations', 'selectAll')">Select All</div>
															<div class="custom-ng-select-btn" (click)="selectRemoveAll('WorkLocations', 'removeAll')">Select None</div>
														</div>
													</ng-template>
													<ng-template ng-multi-label-tmp let-items="items">
														<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
													</ng-template>
												</ng-select>
												<div class="col-sm-12" *ngIf="loadingWorkLocationsFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
											</div>
										</div>

										<div class="col-sm-3">
											<div class="form-group">
												<label for="workAuthorization">
													Work Authorization
												</label>
												<ng-select *ngIf="!loadingWorkAuthorizationFilter" [items]="workAuthorizationList" bindLabel="name"
													placeholder="None selected" name="workAuthorization" id="workAuthorization"
													[(ngModel)]="selectedWorkAuthorizationList" [closeOnSelect]="false" [multiple]="true"
													(change)="onWorkAuthorizationClick()">
													<ng-template ng-header-tmp>
														<div class="d-flex">
															<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('sponsorships', 'selectAll')">Select All</div>
															<div class="custom-ng-select-btn" (click)="selectRemoveAll('sponsorships', 'removeAll')">Select None</div>
														</div>
													</ng-template>
													<ng-template ng-multi-label-tmp let-items="items">
														<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
													</ng-template>
												</ng-select>
												<div class="col-sm-12" *ngIf="loadingWorkAuthorizationFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
											</div>
										</div>

										<div [ngClass]="{'col-sm-12 px-0': ((checkPreferredJobType('CONTRACTTOHIRE') || checkPreferredJobType('CONTRACTOR')) && isPreferredJobTypeNotFullTime)}">
											<div class="col-sm-3">
												<div class="form-group">
													<label for="preferredJobType">
														Pref. Job Type
													</label>
													<ng-select *ngIf="!loadingPreferredJobTypeFilter" [items]="preferredJobTypeList" bindLabel="name"
														placeholder="None selected" name="preferredJobType" id="preferredJobType"
														[(ngModel)]="selectedPreferredJobTypeList" [closeOnSelect]="false" [multiple]="true"
														(change)="onPreferredJobTypeClick()">
														<ng-template ng-header-tmp>
															<div class="d-flex">
																<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('PreferredJobType', 'selectAll')">Select All</div>
																<div class="custom-ng-select-btn" (click)="selectRemoveAll('PreferredJobType', 'removeAll')">Select None</div>
															</div>
														</ng-template>
														<ng-template ng-multi-label-tmp let-items="items">
															<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
														</ng-template>
													</ng-select>
													<div class="col-sm-12" *ngIf="loadingPreferredJobTypeFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
												</div>
											</div>

											<div class="col-sm-3"
												*ngIf="checkPreferredJobType('CONTRACTTOHIRE') || checkPreferredJobType('CONTRACTOR')">
												<div class="form-group mb-0">
													<label for="additionalPreferredJobTypes">
														Addl. Contract Type
													</label>
													<ng-select *ngIf="!loadingAdditionalPreferredJobTypeFilter" [items]="preferredJobTypeAdditionalList" bindLabel="name"
														placeholder="None selected" name="additionalPreferredJobTypes" id="additionalPreferredJobTypes"
														[(ngModel)]="selectedPreferredJobTypeAdditionalList" [closeOnSelect]="false" [multiple]="true"
														(change)="onAdditionalPreferredJobTypeClick()">
														<ng-template ng-header-tmp>
															<div class="d-flex">
																<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('jobSubTypes', 'selectAll')">Select All</div>
																<div class="custom-ng-select-btn" (click)="selectRemoveAll('jobSubTypes', 'removeAll')">Select None</div>
															</div>
														</ng-template>
														<ng-template ng-multi-label-tmp let-items="items">
															<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
														</ng-template>
													</ng-select>
													<div class="col-sm-12" *ngIf="loadingAdditionalPreferredJobTypeFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
												</div>
											</div>

											<div class="col-sm-6" *ngIf="candidatesContainer.candidatesQueryFilter.candidateType != 'VENDOR_CANDIDATES'">
												<div class="d-flex border px-1" style="height: 78px; border-radius: 5px;">
													<div class="col-sm-6 d-flex">
														<div class="col-sm-4 pl-0">
															<div class="form-group mb-0">
																<label for="candidatesSearchSalary" class="mb-0 mt-2">Salary</label>
																<input type="number" id="candidatesSearchSalary" name="candidatesSearchSalary" min="1"
																	class="inputBoxTransactionRequisition inputBoxBorder mt-1"
																	[(ngModel)]="candidatesContainer.candidatesQueryFilter.salary"
																	(keyup)="onGlobalFilterChange()" (ngModelChange)="addToDisplayFilters('salary')">
															</div>
														</div>

														<div class="col-sm-4">
															<div class="form-group mb-0">
																<label for="Salary" class="mb-0 mt-2">
																	Per
																</label>
																<div class="mt-1 pl-0">
																	<select class="form-control" name="salaryDuration" id="salaryDuration"
																		[(ngModel)]="candidatesContainer.candidatesQueryFilter.salaryDuration"
																		(change)="onSalaryDurationChange()">
																		<option *ngFor="let salaryDuration of filterSalaryDurationOptions"
																			value="{{salaryDuration.value}}" title="{{salaryDuration.name}}">
																			{{salaryDuration.name}}
																		</option>
																	</select>
																</div>
															</div>
														</div>

														<div class="col-sm-4 pr-0">
															<div class="form-group mb-0">
																<label for="salaryCurrency" class="mb-0 mt-2">
																	Currency
																</label>
																<div class="mt-1 pl-0">
																	<select class="form-control" name="currency" id="salaryCurrency"
																		[(ngModel)]="candidatesContainer.candidatesQueryFilter.currency"
																		(change)="onSalaryOrRateCurrencyChange('salary')">
																		<option *ngFor="let currency of currencyCodes" value="{{currency}}"
																			title="{{currency}}">
																			{{currency}}
																		</option>
																	</select>
																</div>
															</div>
														</div>
													</div>
													<span class="mt-5 mx-1 pt-2">OR</span>
													<div class="col-sm-6">
														<div class="col-sm-4 pl-0">
															<div class="form-group mb-0">
																<label for="candidatesSearchRate" class="mb-0 mt-2">Rate</label>
																<input type="number" id="candidatesSearchRate" name="candidatesSearchRate" min="1"
																	class="inputBoxTransactionRequisition inputBoxBorder mt-1"
																	[(ngModel)]="candidatesContainer.candidatesQueryFilter.rate"
																	(keyup)="onGlobalFilterChange()" (ngModelChange)="addToDisplayFilters('rate')">
															</div>
														</div>

														<div class="col-sm-4">
															<div class="form-group mb-0">
																<label for="rateDuration" class="mb-0 mt-2">
																	Per
																</label>
																<div class="mt-1 pl-0">
																	<select class="form-control" name="rateDuration" id="rateDuration"
																		[(ngModel)]="candidatesContainer.candidatesQueryFilter.rateDuration"
																		(change)="onRateDurationChange()">
																		<option *ngFor="let rateDuration of filterRateDurationOptions"
																			value="{{rateDuration.value}}" title="{{rateDuration.name}}">
																			{{rateDuration.name}}
																		</option>
																	</select>
																</div>
															</div>
														</div>

														<div class="col-sm-4 pr-0">
															<div class="form-group mb-0">
																<label for="rateCurrency" class="mb-0 mt-2">
																	Currency
																</label>
																<div class="mt-1 pl-0">
																	<select class="form-control" name="currency" id="rateCurrency"
																		[(ngModel)]="candidatesContainer.candidatesQueryFilter.currency"
																		(change)="onSalaryOrRateCurrencyChange('rate')">
																		<option *ngFor="let currency of currencyCodes" value="{{currency}}"
																			title="{{currency}}">
																			{{currency}}
																		</option>
																	</select>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

										</div>

										<div [ngClass]="{'col-sm-12 px-0 d-flex': candidatesContainer.candidatesQueryFilter.candidateType == 'OWN_CANDIDATES'}">
											<div class="col-lg-3 col-sm-3 col-md-3" *ngIf="companyType == 'Corporation' && candidatesContainer.candidatesQueryFilter.candidateType == 'VENDOR_CANDIDATES'">
												<div class="form-group">
													<label for="vendors">Vendors</label>
													<ng-select *ngIf="!loadingVendorsFilter" [items]="vendors" bindLabel="name"
														placeholder="None selected" name="vendors" id="vendors"
														[(ngModel)]="selectedVendors" [closeOnSelect]="false" [multiple]="true"
														(change)="onVendorClick()">
														<ng-template ng-header-tmp>
															<div class="d-flex">
																<div class="mr-2 custom-ng-select-btn" (click)="selectRemoveAll('Vendors', 'selectAll')">Select All</div>
																<div class="custom-ng-select-btn" (click)="selectRemoveAll('Vendors', 'removeAll')">Select None</div>
															</div>
														</ng-template>
														<ng-template ng-multi-label-tmp let-items="items">
															<span class="ng-value">{{ getMultiSelectSummary(items, 'name') }}</span>
														</ng-template>
													</ng-select>
													<div class="col-sm-12" *ngIf="loadingVendorsFilter">
	<div class="skeleton-loading candidates-filter-skeleton"></div>
</div>
												</div>
											</div>

											<div class="col-lg-3 col-sm-3 col-md-3">
												<div class="form-group">
													<label for="sortBy">Sort By</label>
													<div class="multiSelect dropdown" id="sortBy">
														<button class="dropdown-toggle form-control access inputBoxBorder" type="button" data-toggle="dropdown">
															<span>{{selectedSort}}</span>
															<span *ngIf="selectedSort != 'Please Select' && selectedSortDirection == 'Asc'" class="sort-direction">
																<span class="fa fa-arrow-up"></span>
																<span>(Asc)</span>
															</span>
															<span *ngIf="selectedSort != 'Please Select' && selectedSortDirection == 'Desc'" class="sort-direction">
																<span class="fa fa-arrow-down"></span>
																<span>(Desc)</span>
															</span>
															<span class="caret"></span>
														</button>
														<ul class="dropdown-menu candidate-dropdown" style="width: 100%; height: 150px; overflow: scroll">
															<li (click)="sortCandidates(null,'')">
																<a href="javascript:void(0)">
																	Please Select
																</a>
															</li>
															<ng-container *ngFor="let sortByFilter of sortByFilters">
																<li (click)="sortCandidates(sortByFilter,'Asc')">
																	<a href="javascript:void(0)">
																		{{sortByFilter.columnDisplayName}} (Asc)
																		<span class="fa fa-arrow-up"></span>
																	</a>
																</li>
																<li (click)="sortCandidates(sortByFilter,'Desc')">
																	<a href="javascript:void(0)">
																		{{sortByFilter.columnDisplayName}} (Desc)
																		<span class="fa fa-arrow-down"></span>
																	</a>
																</li>
															</ng-container>
														</ul>
													</div>
												</div>
											</div>
										</div>

									</div>
								</div>
							</div>
							<div class="row pull-right">
								<div class="col-lg-12 col-md-12 col-sm-12">
									<div class="form-group" id="resetFiltersButton" style="position: relative;">
										<button type="button" class="btn btn-primary mr-2" (click)="queryCandidates()" [ngClass]="{'highlight-search-button': isFiltersChanged}"
											[disabled]="loadingClientsOrBusFilter || loadingCandidateStatusesFilter || loadingCandidateStatusesFilter
											|| loadingRequisitionStatusesFilter || loadingRequisitionNumbersFilter || loadingJobMatchStatesFilter
											|| loadingVendorsFilter || loadingRecruitersFilter">
											<span *ngIf="!candidatesContainer.loadingSearchButton">Search</span>
											<span *ngIf="candidatesContainer.loadingSearchButton">
												<span>Searching...</span>
												<span class="fa fa-spinner fa-spin"></span>
											</span>
										</button>
										<button type="button" class="btn btn-danger" (click)="resetCandidateQueryFilters()">Reset</button>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!--filter ends-->
</div>
<!-- Display Selected Filter Start -->
<div class="row mx-0" *ngIf="displayCandidateFilterFlag">
	<div class="main-box">
		<div class="row my-3 pr-4 mr-1">
			<div class="col-xs-11">
				<div class="text-center pl-5" *ngIf="candidatesContainer.isFilterOn">
					<span class="badge badge-primary px-3 py-2 ml-5">Filtered Results</span>
				</div>
			</div>
			<div class="col-xs-1">
				<div class="pull-right">
					<span *ngIf="!displayCandidateSelectedFilter.showCandidateDisplayFilterIcon"
						(click)="displaySelectedFilterToggle()">
						<i class="fas fa-plus cursor-pointer" style="font-size: 20px"></i>
					</span>
					<span *ngIf="displayCandidateSelectedFilter.showCandidateDisplayFilterIcon"
						(click)="displaySelectedFilterToggle()">
						<i class="fas fa-minus cursor-pointer" style="font-size: 20px"></i>
					</span>
				</div>
			</div>
		</div>
		<div *ngIf="showCandidateDisplaySelectedFilterPanel" id="display-candidate-selected-filter-panel" style="background-color: white; padding: 5px 20px;">
			<span *ngFor="let events of candidateFilterItemsSelected; let parentIndex = index">
				<span *ngIf="isFilterValueArray(events.value)">
					<span *ngFor="let event of events.value | slice:0:events.setSelectedFilterLimit; let index = index">
						<span class="pb-4 d-inline-block">
							<span *ngIf="index == 0">
								<span>( </span>
								<span class="font-bold">{{events.variable}} = </span>
							</span>
							<span class="candidate-filter-chip-wrapper">
								<span class="px-2 py-1 text-black rounded candidate-selected-filter">{{event}}</span>
								<span class="position-absolute">
									<i class="fas fa-times-circle text-danger position-relative cursor-pointer candidate-filter-close-icon"
										(click)="deleteSelectedFilterItem(event)"
										style="font-size: 13px;">
									</i>
								</span>
							</span>
							<span *ngIf="events.value.length !== 5 && index == 4 && !events.expandSelectedFilter"
								class="py-1 text-black cursor-pointer"
								(click)="events.setSelectedFilterLimit = events.value.length; events.expandSelectedFilter = true">
								<span tooltip="Expand Filters" container="body" class="font-bold pl-2"
									style="color:#03a9f4;">...</span>
							</span>
							<span *ngIf="!(index == (events.value.length -1) || index == (events.setSelectedFilterLimit-1))"
								class="px-2">OR</span>
							<span *ngIf="index == (events.value.length -1) || index == (events.setSelectedFilterLimit-1)">
								<span>)</span>
								<span *ngIf="!(parentIndex == (candidateFilterItemsSelected.length-1))">
									AND</span>
							</span>
						</span>
					</span>
				</span>
				<span *ngIf="!isFilterValueArray(events.value)" class="pb-4 d-inline-block">
					<span>
						<span>( </span>
						<span class="font-bold">{{events.variable}} = </span>
					</span>
					<span class="candidate-filter-chip-wrapper">
						<span class="px-2 py-1 text-black rounded candidate-selected-filter">{{events.value}}</span>
						<span class="position-absolute">
							<i class="fas fa-times-circle text-danger position-relative cursor-pointer candidate-filter-close-icon"
								(click)="deleteSelectedFilterItem(events.value)"
								style="font-size: 13px;">
							</i>
						</span>
					</span>
					<span> )</span>
					<span *ngIf="candidateFilterItemsSelected.length > 0">
						<span *ngIf="!(parentIndex == (candidateFilterItemsSelected.length-1))">
							<span *ngIf="!isDisplayRateFilterActive || events.variable == 'Rate'">AND</span>
							<span *ngIf="isDisplayRateFilterActive && events.variable == 'Salary'">OR</span>
						</span>
					</span>
				</span>
			</span>
			<span *ngIf="emptyCandidateSelectedFilter && candidatesContainer.isFilterOn">
				No Filter Items Selected
			</span>
		</div>
	</div>
</div>
<!-- Display Selected Filter End -->
<div class="animate-if candidate-cards-container mt-3" infiniteScroll [infiniteScrollDistance]="2"
	[infiniteScrollThrottle]="50" (scrolled)="candidatesContainer.getNext()"
	[infiniteScrollDisabled]="candidatesContainer.busy || candidatesContainer.disableInfiniteScroll"
	*ngIf="candidatesExistFlag && !isRowViewActive">
	<ng-container *ngFor="let candidate of candidatesContainer.candidates; let i = index">
		<div>
			<app-candidate-card [candidateInfo]="candidate" [userId]="userId"
				[candidateType]="candidatesContainer.candidatesQueryFilter.candidateType"
				[jobMatchesPopoverPosition]="candidate.jobMatchesPopoverPosition"
				(setCandidateInfo)="setCandidateInfo($event.candidateInfo, $event.type)" [jobMatchesActiveTab]="candidateJobMatchActiveTab"
				[filterParams]="candidatesContainer.candidatesQueryFilter" [activityMap]="activityMap"
				[salaryDurationOptions]="salaryDurationOptions" [jobTypeList]="preferredJobTypeList"
				[isRowViewActive]="isRowViewActive" [allVendors]="vendors"
				(deleteCallback)="deleteCandidate(candidate.id)">
			</app-candidate-card>
		</div>
		<div class="col-xs-12 candidate-info-container"
			*ngIf="((i + 1) % divident) === 0 || i === candidatesContainer.candidates.length - 1"
			id="candidate-info-{{i + 1}}" style="display: none;">
			<div *ngIf="candidateInfoContainerId == 'candidate-info-' + (i + 1)">
				<ng-container *ngTemplateOutlet="candidateInfoExpand"></ng-container>
			</div>
		</div>
	</ng-container>
</div>
<div class="row animate-if mt-3"
	*ngIf="candidatesContainer.candidatesExistFlag && isRowViewActive && !candidatesContainer.busy">
	<div>
		<div style="min-height: 500px; display: grid;grid-template-columns: minmax(0, 1fr)">
			<ng-container *ngFor="let candidate of candidatesContainer.candidatesPerPage; let i = index">
				<div>
					<app-candidate-card [candidateInfo]="candidate" [userId]="userId"
						[candidateType]="candidatesContainer.candidatesQueryFilter.candidateType"
						[jobMatchesPopoverPosition]="candidate.jobMatchesPopoverPosition"
						(setCandidateInfo)="setCandidateInfo($event.candidateInfo, $event.type)" [jobMatchesActiveTab]="candidateJobMatchActiveTab"
						[filterParams]="candidatesContainer.candidatesQueryFilter" [activityMap]="activityMap"
						[salaryDurationOptions]="salaryDurationOptions" [jobTypeList]="preferredJobTypeList"
						[isRowViewActive]="isRowViewActive" [allVendors]="vendors"
						(deleteCallback)="deleteCandidate(candidate.id)">
					</app-candidate-card>
				</div>
				<div class="col-xs-12 candidate-info-container" id="candidate-info-row-view-{{i + 1}}"
					style="display: none;">
					<div *ngIf="candidateInfoContainerId == 'candidate-info-row-view-' + (i + 1)">
						<ng-container *ngTemplateOutlet="candidateInfoExpand"></ng-container>
					</div>
				</div>
			</ng-container>
		</div>
		<div class="pull-right pr-2 mr-1">
			<pagination [totalItems]="candidatesContainer.candidatesCount" [(ngModel)]="currentCandidatePage"
				[maxSize]="5" [boundaryLinks]="true" [rotate]="false"
				[itemsPerPage]="candidatesContainer.candidatesQueryFilter.pageSize"
				(pageChanged)="onCandidatePageChanged($event)"></pagination>
		</div>
	</div>
</div>
<div class="animate-if candidate-cards-container mt-3" *ngIf="candidatesContainer.busy && !isRowViewActive">
	<ng-container *ngFor="let placeholder of [0, 1, 2, 3, 4, 5, 6, 7]">
		<div *ngIf="candidatesContainer.candidatesQueryFilter.candidateType == 'OWN_CANDIDATES'"
			class="main-box candidate-card-internal-card p-3 d-flex flex-column justify-content-between skeleton-container" style="height:247px;">
			<div class="d-flex flex-column skeleton-container">
				<div class="skeleton-heading width-75 skeleton-loading my-0 mb-2"></div>
				<div class="skeleton-paragraph width-50 skeleton-loading"></div>
			</div>
			<div class="d-flex justify-content-between skeleton-container">
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
			</div>
			<div class="d-flex justify-content-between skeleton-container">
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
			</div>
			<div class="d-flex justify-content-between skeleton-container">
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
			</div>
			<div class="d-flex justify-content-between skeleton-container">
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
			</div>
			<div class="d-flex justify-content-between align-items-center skeleton-container">
				<div class="skeleton-paragraph width-50 skeleton-loading"></div>
				<div class="skeleton-heading width-25 skeleton-loading my-0"></div>
			</div>
		</div>
		<div *ngIf="candidatesContainer.candidatesQueryFilter.candidateType == 'VENDOR_CANDIDATES'"
			class="main-box candidate-card-vendor-card p-3 d-flex flex-column justify-content-between skeleton-container" style="height:260px;">
			<div class="d-flex flex-column skeleton-container">
				<div class="skeleton-heading width-75 skeleton-loading my-0 mb-2"></div>
				<div class="skeleton-paragraph width-50 skeleton-loading"></div>
			</div>
			<div class="d-flex justify-content-between skeleton-container">
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
			</div>
			<div class="d-flex justify-content-between skeleton-container">
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
			</div>
			<div class="d-flex justify-content-between skeleton-container">
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
				<div class="skeleton-paragraph width-25 skeleton-loading"></div>
			</div>
			<div class="d-flex justify-content-between align-items-center skeleton-container">
				<div class="skeleton-paragraph width-50 skeleton-loading"></div>
				<div class="skeleton-heading width-25 skeleton-loading my-0"></div>
			</div>
		</div>
	</ng-container>
</div>
<div class="mt-3" *ngIf="candidatesContainer.busy && isRowViewActive">
	<div class="main-box p-3 mb-2 skeleton-container" *ngFor="let placeholder of [0, 1, 2, 3, 4]">
		<div class="d-flex flex-row align-items-center">
			<div class="skeleton-loading mr-3" style="width: 50px; height: 50px; flex-shrink: 0;"></div>
			<div class="d-flex flex-column flex-grow-1">
				<div class="skeleton-heading width-25 skeleton-loading my-0 mb-2"></div>
				<div class="skeleton-paragraph width-50 skeleton-loading"></div>
			</div>
		</div>
	</div>
</div>
<div class="row animate-if" *ngIf="!candidatesContainer.candidatesExistFlag">
	<div class="col-xs-12 no-candidates-found text-center d-flex flex-column">
		<span class="my-5" style="font-size: 1.2em;">
			No candidates found!
		</span>
		<img src="assets/app-content/img/resume_folder.svg" style="height:180px" alt="No Candidates Found">
	</div>
</div>

<ng-template #candidateInfoExpand>
	<div class="row">
		<div class="col-xs-12" style="padding-left:20px; padding-right:20px;">
			<div class="main-box clearfix" style="padding:10px">
				<div class="row">
					<div class="col-xs-8 col-xs-offset-2" style="margin-top: 10px">
						<h1 class="text-center" *ngIf="infoOfCandidateInContext?.name !== null">
							{{infoOfCandidateInContext.name}}</h1>
						<h1 class="text-center" *ngIf="infoOfCandidateInContext?.name == null"> _______</h1>
					</div>
					<div class="col-xs-2 text-right cursor-pointer" style="margin-top: 10px; padding-right: 15px;">
						<span (click)="closeCandidateInfoRow()">
							<i class="fa fa-lg fa-times"></i>
						</span>
					</div>
				</div>
				<div class="row">
					<div class="col-xs-12">
						<tabset *ngIf="candidateInfoContainerId != null">
							<tab heading="Current Job Matches" [active]="activeTabIndex == 1"
								(selectTab)="candidateJobMatchesTabChanged('jobMatches')">
								<app-candidate-job-matches *ngIf="activeTabIndex == 1"
									[candidateId]="infoOfCandidateInContext.id"
									[vendorIds]="candidatesContainer.candidatesQueryFilter.vendors"
									[candidateType]="candidatesContainer.candidatesQueryFilter.candidateType"
									[userId]="userId">
								</app-candidate-job-matches>
							</tab>
							<tab heading="Possible Job Matches" [active]="activeTabIndex == 2"
								(selectTab)="candidateJobMatchesTabChanged('possibleJobMatches')"
								*ngIf="candidatesContainer.candidatesQueryFilter.candidateType == 'OWN_CANDIDATES'">
								<app-candidate-possible-job-matches *ngIf="activeTabIndex == 2"
									[candidateId]="infoOfCandidateInContext.id"
									[candidateName]="infoOfCandidateInContext.name"
									[candidateType]="candidatesContainer.candidatesQueryFilter.candidateType"
									[userId]="userId">
								</app-candidate-possible-job-matches>
							</tab>
						</tabset>
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-template>
